<template>
  <div class="terms">
    <!-- eslint-disable -->
    <pre class="text">
            利用規約

            第１章　総則 

            （本規約の目的） 
            第１条　株式会社ブレインスリープ（以下「当社」といいます。）は、睡眠偏差値forBiz 
            利用規約（以下「本規約」といいます。）を定め、これにより「睡眠偏差値forBiz」（以下「本サービス」といいます。）を提供します。 
            当社は本方針を、法令変更への対応の必要性および事業上の必要性等に応じて、随時、変更および改正する場合があり、当該変更等について、当サービスページ上に掲載します。お客様は、当サイト上に掲載される変更等の後の最新の本方針の内容を十分にご確認ください。 

            （用語の定義） 
            第２条　本規約においては、次の用語はそれぞれ次の意味で使用します。 
            用語 用語の意味 
            (1)電気通信設備とは電気通信を行うための機械、器具、線路その他の電気的設備のことをいう 
            (2)自営端末設備とは利用者が利用する端末設備のことをいう 
            (3) 睡眠偏差値forBizとは当社が設置するサーバ設備その他の電気通信設備により、睡眠の質を判断するアプリケーション等を提供するサービスのことをいう 
            (4)利用者 睡眠偏差値forBizを用いて睡眠の質を判断する者のことをいう 
            (5)利用者ＩＤ 受講者を特定するために、当社が定める任意の英字及び数字等の組み合わせのことをいう 

            第２章　本サービスの提供 
            （本サービスの内容） 
            第３条　当社は本サービスにつき随時その内容の見直しを図っておりますが、本サービスに事実上または法律上の欠陥（安全性,信頼性,正確性,完全性,有効性,特定の目的への適合性,セキュリティなどに関する欠陥,エラーやバグ,権利侵害などを含みます。）がないことを保証するものではありません。 

            第３章　利用 
            （権利の譲渡の禁止） 
            第４条　本サービスの提供を受ける権利は利用者のみに帰属するものであり、本サービスの提供を受ける権利を第三者に譲渡、承継、売買、又は質権の設定その他担保に供すること等をしてはならないものとします。 

            第４章　禁止行為 
            （営業活動の禁止） 
            第５条　利用者は、有償、無償を問わず、本サービスの全部又は一部を再提供することはできません。 
            （著作権等） 
            第６条　本サービスにおいて当社が利用者に提供する一切の物品等（本規約、各種ソフトウェア、取扱マニュアル、ホームページ、メールマガジン等を含みます。）に関する著作権、特許権、商標権、ノウハウ等の一切の知的所有権は、当社又は当該物品等の使用を当社に対して許可する者に帰属するものとします。 
            ２　利用者は、前項の物品等を以下のとおり取り扱っていただきます。 
            (1)本サービスの利用目的以外に使用しないこと。 
            (2)複製・改変・編集等を行わず、また、リバースエンジニアリング、逆コンパイル又は逆アセンブルを行わないこと。 
            (3)営利目的有無を問わず、第三者に貸与・譲渡・担保設定等しないこと。 
            (4)当社又は本サービスの提供に不可欠な当社の契約事業者が表示した著作権表示等を削除又は変更しないこと。 

            第５章　利用中止等 

            （利用中止）
            第７条　当社は、当社の判断で、いつでも本サービスの一部または全部の利用を中止することができるものとします。ただし、事前に当社WEBサイト（https://suiminhensachi.com/）内で通知した上で実施するものとします。 
            ２　当社は、前項の規定により本サービスの利用を中止するときは、あらかじめインターネットの利用その他の当社が適切と判断する方法により周知します。ただし、緊急やむを得ない場合は、この限りではありません。 
            （利用停止） 
            第８条　当社は、当社の判断で、いつでも本サービスの一部または全部の利用を停止することができるものとします。ただし、事前に当社WEBサイト（https://suiminhensachi.com/）内で通知した上で実施するものとします。 
            （本サービス提供の終了） 
            第９条　当社の判断で、いつでも本サービスの一部または全部の提供を終了することができるものとします。ただし、終了日の30日前までには当社WEBサイト（https://suiminhensachi.com/）内で通知するものとします。 

            第６章　料金 
            （料金） 
            第１０条　当社が提供する本サービスの料金は、有償です。具体的な金額については別途個別契約で定めるものとします。 

            第７章　損害賠償 
            （責任の制限） 
            第１１条　当社は、当社のサーバ装置その他の電気通信設備に蓄積されたデータが滅失したことにより発生する損害については、責任を負いません。利用者は自己の責任でデータのバックアップを行うものとします。 
            （免責事項） 
            第１２条　当社は、随時本サービスの機能を変更します。コンテンツ、サービスおよびソフトウェアは、予告なく変更されることがあるものとします。 
            ２　前項の変更の結果、データ、機能性または有用性の喪失が生じることがあるものとし、利用者は、本サービスに基づき当社が前項の変更を行うこと、および法令に別段の定めがない限り当社はデータ、コンテンツ、機能性および有用性の喪失などについて一切の責任を負わないことについて同意するものとします。 
            ３　本サービスを利用したことにより何らかの不具合、損害等が発生した場合でも、当社はこれらに対する責任（補償や賠償を含むが、これらに限られない）は一切行わないものとします。 
            ５　利用者は、本サービスの利用により第三者に対し損害を与えた場合は、自己の責任でこれを解決するものとします。 
            ６　当社は、本サービスの利用により生じる結果について、本サービスの提供に必要な設備の不具合、故障、第三者による不正侵入、商取引上の紛争、法令等に基づく強制的な処分その他の原因を問わず、責任を負いません。 
            ７　当社は、第８条（利用中止）、第９条（利用停止）、第１０条（本サービス提供の終了）の規定により本サービスの利用中止、利用停止、利用の制限及び本サービス提供の終了をしたことに伴い生じる利用者の損害について、責任を負いません。 
            ８　当社は、サイバーテロ、自然災害、第三者による妨害等、不測の事態を原因として発生した損害については、責任を負いません。（サイバーテロとは、コンピュータ・ネットワークを通じて各国の国防、治安等を始めとする各種分野のコンピュータ・システムに侵入し、データを破壊、改ざんするなどの手段で国家又は社会の重要な基盤を機能不全に陥れるテロ行為をいいます。） 

            第８章　個人情報の取扱い 
            （個人情報の取扱い） 
            第１３条　 
            １　当社は、本サービスに基づき利用者が回答した調査等のすべての情報（以下「回答情報」といいます。）を取得します。取得した情報を管理・利用する業務に従事する者は、お客様の取得情報について厳重に管理し、個人情報への不当なアクセス、紛失、漏洩、改ざん等が起きないよう情報の取扱に十分な注意を行います。 その主な内容は以下のとおりです。 
            （人的安全管理措置） 
            •個人データの取扱いに関する留意事項について、従業者に定期的な研修を実施しています。 
            （物理的安全管理措置） 
            •個人データを取り扱う区域において、従業者の入退室管理及び持ち込む機器等の制限を行うとともに、権限を有しない者による個人データの閲覧を防止する措置を実施しています。 
            （技術的安全管理措置） 
            •アクセス制御を実施して、担当者及び取り扱う個人情報データベース等の範囲を限定しています。 
            •個人データを取り扱う情報システムを外部からの不正アクセス又は不正ソフトウェアから保護する仕組みを導入しています。 

            また当社は、氏名等のお客様を特定する情報を保有しない第三者から、識別子や行動履歴など、お客様に関連する情報（個人関連情報）の提供を受け、当該情報を私たちが管理するお客様の個人情報と紐づけることで個人情報として取得し、別途の目的が示されている場合を除き、上記  でご説明した目的にしたがって、当該情報を利用することがあります。具体的には、Cookie等、モバイル広告識別子、メールアドレスや電話番号（不可逆的な変換処理がなされたものを含みます。）、広告の閲覧回数等の広告配信関連ログ、ウェブサイトの閲覧履歴や検索履歴、実店舗でのショッピングを含む購買履歴、位置情報その他の行動履歴、TV視聴関連ログ等を取得し、私たちが管理する個人情報と紐づけて利用する場合があります。この場合は、適用法令に従い、個人情報として適切に取り扱います。  これらは次の目的に利用することがあります。当社が以下の利用目的を超えて利用することはありません。   

            (1) 本サービスに関する利用者の管理のため 
            (2) 本サービスにおけるご本人確認及び不正利用の防止のため 
            (3) 本サービスに関する通知、連絡、問い合わせ等への対応のため 
            (4) 本サービスの提供、拡充、改善、新規開発のための調査・分析のため 
            (5) 本サービスのご意見をお伺いするため 
            (6) 当社の新たなサービスの通知または提供のため 
            (7) 注文された商品の発送、お問い合わせ対応や利用後のアフターサービス、新商品やサービスに関する情報の提供のため 
            (8) 属性情報、行動履歴、端末情報、位置情報、ご意見、ご要望、お問合せ等の情報に基づく広告、宣伝、販売促進、コンテンツ等の配信および送付のため。（当社サービスに関する情報、メールマガジン、商品案内、ダイレクトメール等） 
            (9) 個人が特定できない統計情報に変換した上、当社の協力企業となりうる企業、広告主、その他の第三者への当社サービスの説明、その他合法的な目的のために利用、開示させていただくためこれは当サイト上でのサービス及び当社から送信されるサービス向上のためのDMやアンケートのご依頼、新商品・サービス・キャンペーン等の電話によるご案内、お客様へのご返金、その他業務上必要な範囲でのご連絡等に利用及び製品の開発・改良に利用させていただきます。 
            ２　利用者は、当社が、回答情報は個人を特定しない情報として、次に定める目的のために回答情報を利用することについて同意していただきます。 
            (1) 調査結果の確認、分析、その他マーケティング・リサーチの実施に必要な事項 
            (2) 製品やソリューション開発や修正などの実施に必要な事項 
            (3) セミナーやイベント、キャンペーンなどの実施に必要な事項 
            (4) ターゲティング広告の配信 
            (5) 研究や調査の実施に必要な事項 
            (6) 広告配信モデル、購買予測モデル、その他のマーケティング・ソリューションの開発および改善 
            (7) 再調査や追加での診断 
            (8) その他上記に付帯または関連する事項 

            ３　当社は、回答情報を当社及び東日本電信電話株式会社ならびに当社又は東日本電信電話株式会社が指定した第三者に対して前項記載の目的のために、直接特定の個人を識別することができない情報として提供することがあります。 

            第９章　保守 
            （利用者の切分責任） 
            第１４条　利用者は、本サービスを利用することができなくなったときは、その本サービスを利用する自営端末設備に故障の無いことを確認のうえ、当社に修理の請求をしていただきます。 
            ２
            前項の確認に際して、利用者から要請があったときは、当社は睡眠偏差値forBiz取扱所において試験を行い、その結果を利用者にお知らせします。 

            第１０章　雑則 
            （承諾の限界） 
            第１５条　当社は、利用者から工事その他の請求があった場合に、その請求を承諾することが技術的に困難なとき又は保守することが著しく困難である等当社の業務の遂行上支障があるときは、その請求を承諾しないことがあります。この場合は、その理由を利用者に通知します。ただし、本規約において別段の定めがある場合は、その定めるところによります。 
            （利用に係る契約者の義務） 
            第１６条　利用者は、当社が付与した利用者ＩＤを善良な管理者の注意をもって保管するよう注意するものとします。 

            利用者は、自己の責任において、本サービスを利用するために必要な自営端末設備、通信回線その他の設備を維持、管理するものとします。 
            （法令に規定する事項） 
            第１７条　本サービスの提供又は利用にあたり、法令に定めがある事項については、その定めるところによります。 
            （準拠法） 
            第１８条　本規約の成立、効力、解釈及び履行については、日本国法に準拠するものとします。 
            （紛争の解決） 
            第１９条　本規約の条項又は本規約に定めのない事項について紛議等が生じた場合、双方誠意をもって協議し、できる限り円満に解決するものとします。 

            ２　本規約に関する紛争は、東京地方裁判所を第一審の専属的合意管轄裁判所とします。 
            （反社会的勢力の排除） 
            第２０条　利用者は、次の各号のいずれにも該当しないことを表明し、将来にわたって次の各号のいずれにも該当しないことを確約します。 
            (1)自ら又は自らの役員（取締役、執行役又は監査役が、暴力団（暴力団員による不当な行為の防止等に関する法律（平成３年法律第７７号）第２条第２号）、暴力団員（暴力団員による不当な行為の防止等に関する法律第２条第６号）、暴力団員でなくなった時から５年間を経過しない者、もしくはこれらに準ずる者、又は暴力団若しくは暴力団員と密接な関係を有する者（以下、これらを個別に又は総称して「暴力団員等」という。）であること。 
            (2)自らの行う事業が、暴力団員等の支配を受けていると認められること。 
            (3)自らの行う事業に関し、暴力団員等の威力を利用し、財産上の不当な利益を図る目的で暴力団員等を利用し、又は、暴力団員等の威力を利用する目的で暴力団員等を従事させていると認められること。 
            (4)自らが暴力団員等に対して資金を提供し、便宜を供与し、又は不当に優先的に扱うなどの関与をしていると認められること。 
            (5)本利用の履行が、暴力団員等の活動を助長し、又は暴力団の運営に資するものであること。 
            ２　当社は、利用者が次の各号の一に該当するときは、何らの通知、催告を要せず即時に本サービスの提供を中止することができます。 
            (1)第１項に違反したとき。 
            (2)自ら又は第三者をして次に掲げる行為をしたとき。 
            ①当社もしくは当社の委託先に対する暴力的な要求行為 
            ②当社もしくは当社の委託先に対する法的な責任を超えた不当な要求行為 
            ③当社もしくは当社の委託先に対する脅迫的言辞又は暴力的行為 
            ④風説を流布し、又は偽計若しくは威力を用いて、当社もしくは当社の委託先の信用を毀損し、又は当社もしくは当社の委託先の業務を妨害する行為 

            ⑤その他前各号に準ずる行為 
            ３　当社は、前項の規定により本サービスの提供を中止した場合、利用者に損害が生じても、これを賠償する責を負わないものとします。 

            （通知） 
            第２１条 
            利用者は名称（会社名、氏名）、住所、連絡先、連絡担当者、連絡担当者連絡先を当社に届け出るものとし、変更があった場合には変更を届け出るものとする。届出がなかったことにより利用者が被った損害については当社は責任を負わないものとします。 

            お客様個人情報のお問い合わせ窓口 
            この利用規約をもちまして、個人情報の取り扱い及び収集に関してのお客様の同意とさせていただきます。同意されない場合、並びに当社の個人情報の取り扱いに関してご不明な点等がございましたら、お手数ですが、当社お問い合わせ窓口までご連絡ください。 

            お問い合わせ先：suiminhensachi@brain-sleep.com 

            本文書は、2022年11月1日に更新致しました。当社はこの利用規約の全部又は一部を変更する場合があります。この場合には、当社サービスページ上において変更したプライバシーポリシーを掲載するものとします。 

            個人情報取扱事業者の住所　 
            東京都千代田区丸の内二丁目7番2号 
            個人情報取扱事業者である法人の代表の氏名　 
            株式会社ブレインスリープ　代表取締役　廣田敦
        </pre
    >
    <!-- eslint-able -->
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.text {
  max-width: 100%;
  white-space: pre-line;
  font-size: 13px;
}
</style>